import { FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import _ from "../../../../../i18n";
import {
    formatAmount,
    getUserNameForAvatar,
    renderDurationDisplay,
} from "../../../../../utils";
import styles from "./TSCard.module.scss";

export default function TSCard({
  collaboratorId,
  name,
  grade,
  timesheet,
  lng,
}) {
  return (
    <div className={styles.ts_card}>
      <div className={styles.header}>
        <Avatar name={name} grade={grade} />
        <div className={styles.person_info}>
          <h3>{name}</h3>
          <h4 className={styles[grade]}>{grade}</h4>
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.timesheet_info}>
          <div className={styles.info_row}>
            <span className={styles.label}>{_("theoric")}</span>
            <span className={styles.value}>
              {renderDurationDisplay(timesheet.theoric)}
            </span>
          </div>
          <div className={styles.info_row}>
            <span className={styles.label}>{_("real")}</span>
            <span className={styles.value}>
              {renderDurationDisplay(timesheet.real)}
            </span>
          </div>
          <div className={styles.info_row}>
            <span className={styles.label}>{_("volumetry")}</span>
            <span className={styles.value}>{timesheet.volumetry}</span>
          </div>
          <div className={styles.info_row}>
            <span className={styles.label}>{_("fees")}</span>
            <span className={styles.value}>{formatAmount(timesheet.fee)}</span>
          </div>
        </div>
      </div>

      <Link
        to={`/${lng}/fiche-collaborator/${collaboratorId}`}
        className={styles.link}
      >
        <FiArrowUpRight color="#29394D" size={18} />
      </Link>
    </div>
  );
}

const Avatar = ({ name, grade }) => {
  return (
    <div className={`${styles.avatar} ${styles[`avatar_${grade}`]}`}>
      <span>{getUserNameForAvatar(name)}</span>
    </div>
  );
};
